<template>
  <main>
    <Trail :list="trail" />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <template v-if="newsLetter">
            <Title tag="h1" v-if="newsLetter">Boletín</Title>
            <Title tag="h2" theme="primary" v-if="newsLetter">
              {{ newsLetter.title }}
            </Title>
          </template>
          <Title tag="h1" v-else>Boletines Atmósfera - Hidrósfera</Title>
          <Content v-if="content" :content="content" />
          <div v-else>
            <p>
              Los eventos meteorológicos e hidroclimaticos, llamados “eventos
              extremos” son aquellos que ocurren muy rara vez, pero cuando lo
              hacen constituirse como un peligro importante para la sociedad. En
              el Perú, debido a su compleja geografía, existen zonas expuestas a
              estos peligros, siendo por lo general, las áreas urbanas quienes
              presentan una alta vulnerabilidad. Por ejemplo, el fenómeno El
              Niño genera lluvias extremas en la costa norte y sequías en los
              andes centrales y el sur. Por otro lado, la sierra, donde hay
              población y se desarrollan actividades agrícolas por encima de los
              4000 msnm de altura, esta expuesta a bajas temperaturas y heladas
              durante la temporada seca, alta insolación durante el día y a
              lluvias intensas durante la temporada húmeda. Todos estos peligros
              causan huaicos, deslizamientos y avalanchas, y a la vez pueden
              ocurrir sequías y veranillos. La Amazonía, por su parte, también
              alterna periodos de sequías e inundaciones, así como friajes con
              graves consecuencias para la población y el ecosistema.
            </p>
            <p>
              El estudio de estos eventos extremos, han sido parte de
              importantes proyectos de investigación desarrollados en el IGP
              para comprender su origen y desarrollo, así como los niveles de
              exposición de la población, la agricultura y obras de ingeniería.
              Asimismo, estos proyectos han permitido contar con instrumentación
              especializada para su monitoreo y ello, ha permitido generar
              información continua en el tiempo que nos permite hacer su
              seguimiento y la identificación de anomalías en sus procesos que
              puedan se utilizadas para dar alertas y así, reducir el riesgo al
              cual nos encontramos expuestos. Con esta finalidad, se ha iniciado
              la publicación de los Boletines
              <router-link to="/boletines/incendios-forestales">
                “Indicadores de la vegetación andina amazónica para la
                prevención de incendios forestales”
              </router-link>
              y
              <router-link to="/boletines/valle-mantaro">
                “Eventos fríos y lluviosos en el valle de Mantaro”
              </router-link>
              , esperando que sea de interés de autoridades y población en
              general.
            </p>
          </div>
        </ColumnUi>
        <!--
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(subp, index) in subprograms" :key="index">
              <router-link
                v-if="!newsLetter || newsLetter.slug != subp.slug"
                :to="`/boletines/${subp.slug}`"
              >
                {{ subp.title }}
              </router-link>
              <span v-else>
                {{ subp.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
        -->
        <ColumnUi md="3">
          <div>
            <Title tag="h3" theme="normal"><b>BOLETINES</b></Title>
            <List marked>
              <li v-for="(news, index) in newsLetters" :key="index">
                <router-link
                  v-if="
                    (!newsLetter && news.slug != '') ||
                      (news.slug != '' && newsLetter.slug != news.slug)
                  "
                  :to="`/publicaciones/boletines/${news.slug}`"
                >
                  {{ news.title }}
                </router-link>
                <a
                  v-else-if="news.slug != ''"
                  style="text-decoration: underline; pointer-events: none;"
                >
                  {{ news.title }}
                </a>
                <span v-else class="is-muted">
                  {{ news.title }}
                </span>
              </li>
            </List>
          </div>
          <div v-if="newsLetter">
            <SimpleBox v-if="availableYears.data.length > 1">
              <Button
                v-for="(year, index) in availableYears.data"
                tag="router-link"
                theme="text"
                :to="`/publicaciones/boletines/${subject}?year=${year}`"
                :key="index"
                :class="year == currentYear && 'active'"
                :style="year != currentYear && 'border-color: transparent;'"
              >
                {{ year }}
              </Button>
            </SimpleBox>
            <Loader v-if="loading" />
            <div v-else>
              <ItemList
                v-if="items && items.data"
                :list="items.data"
                :title="currentYear"
              />
              <p v-else>
                No se encontraron registros
              </p>
            </div>
            <!--
            <div
              v-for="(list, index) in newsLetter.bulletins"
              :key="index"
              class="item-list"
            >
              <h3>{{ list.year }}</h3>
              <List>
                <li v-for="(data, index) in list.data" :key="index">
                  <a target="_blank" :href="`${data.path}`">
                    {{ data.title }}
                  </a>
                </li>
              </List>
            </div>
            -->
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getBulletinsByYear, getYearsByCollection } from "@/api/bulletins.js";
import { getNewsletters } from "@/newsletter.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Button from "@/components/ui/atoms/Button.vue";
import SimpleBox from "@/components/ui/objects/SimpleBox.vue";
import Content from "@/components/common/Content.vue";
import ItemList from "@/components/common/ItemList.vue";
import Loader from "@/components/common/Loader.vue";
import { useRoute } from "vue-router";
import { reactive, ref } from "vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content,
    Button,
    SimpleBox,
    ItemList,
    Loader
  },
  setup() {
    let trail = [
      {
        name: "Bulletins",
        path: "/publicaciones/boletines",
        tag: "Boletines"
      }
    ];
    const route = useRoute();
    const url = process.env.VUE_APP_REGEN_API;
    const subject = route.params.subject || "";
    const year = route.query.year;
    const newsLetters = getNewsletters(process.env.VUE_APP_PREFIX);

    const newsLetter = newsLetters.find(
      newsletter => subject && newsletter.slug == subject
    );
    if (newsLetter) {
      trail.push({ name: "Bulletins by Product", tag: newsLetter.title });
    }
    const collection_id = newsLetter && newsLetter.collectionId;
    const availableYears = reactive({ data: [] });

    let content;
    let currentYear = ref();
    let items = reactive({ data: [] });

    let loading = ref(true);

    let getAvailableYears = async () => {
      if (newsLetter) {
        await getYearsByCollection({ url, collection_id }).then(response => {
          availableYears.data = response;
          currentYear.value = year || availableYears.data[0];
          content = newsLetter.content;
          const options = {
            url,
            collection_id,
            year: currentYear.value
          };

          let itemsArray = [];
          getBulletinsByYear(options).then(response => {
            response.items.data.forEach(item => {
              let title = "";
              try {
                title = item.metadata.find(md => md.metadata_field_id == 94)
                  .value;
              } catch (e) {
                title = item.metadata.find(md => md.metadata_field_id == 64)
                  .value;
              }
              itemsArray.push({
                title,
                path: item.url
              });
            });
            items.data = itemsArray.sort((a, b) =>
              a.title < b.title ? 1 : b.title < a.title ? -1 : 0
            );
            loading.value = false;
          });
        });
      }
    };

    getAvailableYears();

    return {
      trail,
      content,
      newsLetter,
      newsLetters,
      availableYears,
      currentYear,
      subject,
      items,
      loading
    };
  }
};
</script>
